export default __webpack_public_path__ + "static/bg-e0fc2b3242111dd59ec34d9fb943df8a.png";